// Centralized API Service for all form submissions

const API_BASE_URL = 'https://leadapi.crmbytes.com/api';
const GEO_API_URL = 'https://validationapi.thetechmenders.com/api/GeoLocation/GetGeoLocation';

// Fetch geolocation data
export const fetchGeolocation = async () => {
  try {
    const response = await fetch(GEO_API_URL, {
      method: 'GET',
      headers: {
        'accept': 'text/plain'
      }
    });
    
    const data = await response.json();
    
    if (data.isSuccess) {
      return {
        success: true,
        data: data.data
      };
    }
    
    return {
      success: false,
      data: null
    };
  } catch (error) {
    console.error('Geolocation fetch error:', error);
    return {
      success: false,
      data: null
    };
  }
};

// Submit lead form
export const submitLead = async (formData) => {
  try {
    // Get geolocation data
    const geoResult = await fetchGeolocation();
    const geoData = geoResult.success ? geoResult.data : null;
    
    // Extract country code from countryCode (e.g., "+1" -> "US", "+44" -> "GB")
    const countryCodeMap = {
      '+1': 'US',
      '+44': 'GB',
      '+91': 'IN',
      '+86': 'CN',
      '+81': 'JP',
      '+82': 'KR',
      '+61': 'AU',
      '+49': 'DE',
      '+33': 'FR',
      '+39': 'IT',
      '+34': 'ES',
      '+7': 'RU',
      '+55': 'BR',
      '+52': 'MX',
      '+27': 'ZA',
      '+971': 'AE',
      '+65': 'SG',
      '+31': 'NL',
      '+46': 'SE'
    };
    
    // Get country code from dial code or use geolocation country
    const country = countryCodeMap[formData.countryCode] || (geoData ? geoData.countryCode : 'US');
    
    // Extract numeric dial code (remove '+')
    const countryDialCode = parseInt(formData.countryCode.replace('+', ''));
    
    // Build payload
    const payload = {
      name: formData.name,
      email: formData.email,
      countryDialCode: countryDialCode,
      country: country,
      phoneNumber: formData.phone, // Only numeric, no dial code
      ipAddress: geoData ? geoData.ipAddress : '',
      description: formData.message || '',
      pageUrl: window.location.href,
      city: geoData ? geoData.cityName : '',
      state: geoData ? geoData.regionName : '',
      geoLocation: geoData ? JSON.stringify({ isSuccess: true, data: geoData, errorMessage: '', statusCode: 200 }) : '',
      packageTitle: formData.packageTitle || '',
      packageAmount: formData.packageAmount || 0,
      tmSignUpType: formData.tmSignUpType || 1
    };
    
    console.log('Submitting lead with payload:', payload);
    
    const response = await fetch(`${API_BASE_URL}/Lead/AddLead`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'text/plain'
      },
      body: JSON.stringify(payload)
    });
    
    const responseData = await response.json();
    
    // Handle different status codes
    if (response.status === 200 && responseData.isSuccess) {
      // Success - redirect to application page
      return {
        success: true,
        customerId: responseData.data.customerId,
        message: responseData.data.message
      };
    } else if (response.status === 401) {
      // Unauthorized
      return {
        success: false,
        error: responseData.message || 'Unauthorized access'
      };
    } else if (response.status === 400) {
      // Bad request
      return {
        success: false,
        error: responseData.errorMessage || responseData.data?.message || 'Invalid data provided'
      };
    } else {
      // Other errors
      return {
        success: false,
        error: responseData.errorMessage || 'An error occurred. Please try again.'
      };
    }
    
  } catch (error) {
    console.error('Lead submission error:', error);
    return {
      success: false,
      error: 'Network error. Please check your connection and try again.'
    };
  }
};
